module.exports = __webpack_public_path__ + "static/media/accel.eadb1d59.svg";